import { Injectable, signal } from '@angular/core';

export type ToastType = 'show' | 'success' | 'error' | 'info' | 'warning';

export interface Toast {
	id: number;
	type: ToastType;
	title?: string;
	message: string;
	closable: boolean;
}

/** Messaggi a comparsa mostrati da app-toast-container (al posto di ngx-toastr). Usare DialogService.showToast. */
@Injectable({ providedIn: 'root' })
export class ToastService {
	private nextId = 0;
	readonly toasts = signal<Toast[]>([]);

	show(toast: Omit<Toast, 'id'>): void {
		this.toasts.update(list => [...list, { ...toast, id: ++this.nextId }]);
	}

	remove(id: number): void {
		this.toasts.update(list => list.filter(t => t.id !== id));
	}

	clear(): void {
		this.toasts.set([]);
	}
}
